export default __webpack_public_path__ + "static/media/cse-top-pick-circle-2019@2x.e9d897a2.png";